import { useState, useRef, useEffect } from "react";
import styles from "./ModalImage.module.css";
import { useMediaQuery } from 'react-responsive'

const ModalImage = ({ src, title }) => {
  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const imgRef = useRef();

  // Сброс состояний при смене src
  useEffect(() => {
    setLoaded(false);
    setError(false);
  }, [src]);

  const handleImgLoad = (e) => {
    console.log("onLoad", e.target.naturalWidth, e.target.naturalHeight);
    setLoaded(true);
  };

  const handleImgError = (e) => {
    console.log("onError", e);
    setError(true);
  };

  useEffect(() => {
    const img = imgRef.current;
    if (img && img.complete && !loaded && !error) {
      handleImgLoad({ target: img });
    }
  }, [src, loaded, error]);

  // ВРЕМЕННО: тестовый src для проверки
  const realSrc = src;

  return (
    <div className={styles.imageWrapper}>
      {!loaded && !error && (
        <div className={styles.skeleton}>
          <div className={styles.skeletonGradient} />
        </div>
      )}
      {error && (
        <div className={`${styles.skeleton} ${styles.error}`}>
          Ошибка загрузки изображения
        </div>
      )}
      <img
        ref={imgRef}
        src={realSrc}
        alt={title}
        className={styles.image}
        decoding="async"
        loading="lazy"
        style={{ visibility: loaded && !error ? "visible" : "hidden" }}
        onLoad={handleImgLoad}
        onError={handleImgError}
      />
      {title && <h2 className={styles.imageTitle}>{title}</h2>}
      {isMobile && (
        <a
          href={realSrc}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.openFull}
          aria-label="Открыть изображение в новой вкладке"
        >
          Открыть в новой вкладке
        </a>
      )}
    </div>
  );
}

export default ModalImage;